import { render, staticRenderFns } from "./AutocompleteDivision.vue?vue&type=template&id=389f3156&scoped=true"
import script from "./AutocompleteDivision.vue?vue&type=script&lang=js"
export * from "./AutocompleteDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f3156",
  null
  
)

export default component.exports